import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { splitDoctorName } from '../../../../common/utils/text';
import { handleChange } from '../../../../utils/form';

function FinishButton() {
  const dispatch = useDispatch();
  const {
    form: { carrierName: carrier = '' },
    doctors: { selectedDoctor },
    validation,
  } = useSelector(store => store);

  function handleClick() {
    let updateFields = {
      pcp_name: selectedDoctor.name,
      pcp_num: selectedDoctor.pcpID,
    };

    if (carrier.toLowerCase() === 'aetna') {
      updateFields = {
        pcp_name: selectedDoctor.name,
        pcp_num: selectedDoctor.pcpID,
        primarycare_id: selectedDoctor.externalID,
      };
    } else if (carrier.toLowerCase() === 'wellcare') {
      updateFields = {
        pcp_name: selectedDoctor.name,
        pcp_num: selectedDoctor.pcpID,
        pcp_ipa: selectedDoctor.externalID,
      };
    } else if (carrier.toLowerCase() === 'anthem') {
      const { firstName, middleName, lastName } = splitDoctorName(selectedDoctor.name);
      updateFields = {
        pcp_first_name: firstName,
        pcp_last_name: lastName,
        pcp_middle_name: middleName,
        pcp_street1: selectedDoctor.address,
        pcp_city: selectedDoctor.city,
        pcp_state: selectedDoctor.state,
        pcp_zip: selectedDoctor.zipcode,
      };
    } else if (carrier.toLowerCase() === 'zing health') {
      updateFields = {
        pcp_name: selectedDoctor.name,
        pcp_num: selectedDoctor.npi,
        primarycare_id: selectedDoctor.pcpID,
      };
    }
    console.log('updateFields: ', updateFields);

    Object.keys(updateFields).forEach(k => {
      const validationRegex = validation[k];
      handleChange({
        value: updateFields[k],
        name: k,
        validationRegex,
        required: false,
      });
    });

    dispatch({ type: 'CLOSE_MODAL', modal: 'doctorsModal' });
    dispatch({ type: 'CLEAR_SELECTED_DOCTOR' });
  }

  return (
    <button
      type="button"
      id="provider-search-search"
      className="btn btn-primary float-end ms-3 fw-bold"
      style={{ width: '120px' }}
      onClick={handleClick}
      disabled={!selectedDoctor.name}
    >
      Finish
    </button>
  );
}
export default FinishButton;
